<template>
  <!-- custom (redesign Modeloja · contrato de largura): Relatórios é superfície de
       dados/dashboard → `.mj-page` (preenche até 1480px, centralizado, gutters 32/40
       do handoff §App Shell). Era max-w-5xl (~1024) → deserto branco em monitor largo.
       O wrapper perde o px-6 — o `.mj-page` é dono do gutter (sem padding duplo). -->
  <div class="overflow-auto bg-n-surface-1 w-full">
    <div class="mj-page pb-12">
      <router-view />
    </div>
  </div>
</template>
